import { call, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getCurrentUser } from '../../publicSession/selectors';
import { request } from '../../xhr';
import { MediaSourceType } from '../types';
import { SCRAPS_FOLDER_ID, ALL_FOLDER_ID } from '@wix/da-url';
import { getGallectionType } from '../helpers';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
export function fakeResponse({ params  }) {
    if (process.env.NODE_ENV !== 'production') {
        const { deviationsByType  } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const { Chance  } = require('chance'); // eslint-disable-line global-require
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        const { folderId , offset , limit  } = params;
        if (folderId === -999) {
            return {
                hasMore: false,
                nextOffset: 0,
                results: []
            };
        }
        const randomDeviations = new Chance().pickset(deviationsByType.pixel.concat(deviationsByType.statuses).concat(deviationsByType.image).concat(deviationsByType.edgeCases).concat(deviationsByType.journal).concat(deviationsByType.literature), limit);
        return {
            hasMore: offset + limit < deviationsByType.image.length,
            nextOffset: offset + limit,
            results: randomDeviations.slice(0, limit)
        };
    }
}
function* fetch(url, params) {
    const response = yield call(request, {
        method: 'get',
        url,
        params
    }, fakeResponse);
    return response;
}
function* handleDeviationStreamFetch(action) {
    const { streamId  } = action;
    const streamParams = yield select(selectors.getStreamParamsSafe, streamId);
    const { folderId , mediaSource , searchQuery  } = streamParams;
    const { currentUser , offset , limit  } = yield select((state)=>({
            currentUser: getCurrentUser(state),
            offset: withOffset.selectors.getNextOffset(state, streamId),
            limit: selectors.getItemsPerFetch(state, streamId)
        }));
    let url = '';
    let params = {};
    if (searchQuery) {
        if (mediaSource === MediaSourceType.GALLERY) {
            url = 'galleries/search';
            const gallerySearchParams = {
                userid: currentUser.userId,
                q: searchQuery,
                offset,
                limit
            };
            params = gallerySearchParams;
        } else if (mediaSource === MediaSourceType.COLLECTION) {
            url = 'favourites/search';
            const faveSearchParams = {
                faver_userid: currentUser.userId,
                q: searchQuery,
                offset,
                limit
            };
            params = faveSearchParams;
        }
    } else {
        url = 'gallection/contents';
        var _getGallectionType;
        const gallectionContentsEndpointParams = {
            username: currentUser.username,
            type: (_getGallectionType = getGallectionType(mediaSource)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
            folderid: folderId,
            offset,
            limit,
            mature_content: true
        };
        if (folderId === SCRAPS_FOLDER_ID) {
            gallectionContentsEndpointParams.scraps_folder = true;
        } else if (folderId === ALL_FOLDER_ID) {
            gallectionContentsEndpointParams.all_folder = true;
        }
        params = gallectionContentsEndpointParams;
    }
    if (!url) {
        return;
    }
    const response = yield call(fetch, url, params);
    // TODO: proper error handling
    if (!response) {
        yield put(withOffset.actions.fetchFailure({
            streamId,
            errorMsg: 'Failed to fetch'
        }));
        return;
    }
    const { hasMore , results , nextOffset  } = response;
    const normalized = results && normalizeDeviations(results);
    var _normalized_result, _normalized_entities;
    yield put(withOffset.actions.fetchSuccessDeduped({
        streamId,
        hasMore: results ? !!hasMore : false,
        items: (_normalized_result = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _normalized_result !== void 0 ? _normalized_result : [],
        entities: (_normalized_entities = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _normalized_entities !== void 0 ? _normalized_entities : {},
        nextOffset: nextOffset !== null && nextOffset !== void 0 ? nextOffset : undefined
    }));
}
export default handleDeviationStreamFetch;
